import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '../../components/Reveal';
import Icon from '../../components/Icon';
import usePageTitle from '../../hooks/usePageTitle';
import forFamiliesFeature from '../../assets/images/for-families-feature.jpg';

export default function ForFamilies() {
  const { t } = useTranslation();
  usePageTitle(t('forFamilies.pageTitle'));
  const steps = t('forFamilies.steps', { returnObjects: true });
  const included = t('forFamilies.included', { returnObjects: true });

  return (
    <>
      <section className="page-hero">
        <div className="shell">
          <Reveal>
            <span className="eyebrow">{t('forFamilies.eyebrow')}</span>
            <h1>{t('forFamilies.title')}</h1>
            <p className="lede">{t('forFamilies.lede')}</p>
            <div className="hero-actions">
              <Link className="btn btn-primary btn-lg" to="/register/family">{t('forFamilies.createAccount')}</Link>
              <Link className="btn btn-outline btn-lg" to="/contact">{t('forFamilies.contactUs')}</Link>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="band band-tint">
        <div className="shell">
          <div className="feature-grid">
            <Reveal className="feature-media">
              <img src={forFamiliesFeature} alt="A mother laughing with her toddler outdoors" />
            </Reveal>
            <Reveal className="feature-copy" delay={100}>
              <span className="eyebrow">{t('forFamilies.everyFamily')}</span>
              <h2>{t('forFamilies.featureTitle')}</h2>
              <p>{t('forFamilies.featureBody')}</p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <Reveal className="section-head">
            <span className="eyebrow">{t('forFamilies.howItWorks')}</span>
            <h2>{t('forFamilies.stepsTitle')}</h2>
          </Reveal>
          <ol className="timeline-steps">
            {steps.map((step, i) => (
              <Reveal as="li" key={step.title} delay={i * 90}>
                <span className="step-number">{i + 1}</span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.body}</p>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <section className="band band-tint">
        <div className="shell">
          <div className="two-col">
            <Reveal>
              <span className="eyebrow">{t('forFamilies.whatYouGet')}</span>
              <h2>{t('forFamilies.whatYouGetTitle')}</h2>
              <p className="section-lede">{t('forFamilies.whatYouGetLede')}</p>
            </Reveal>
            <Reveal delay={120}>
              <ul className="check-list">
                {included.map((item) => (
                  <li key={item}><span className="check-mark"><Icon name="check" size={14} strokeWidth={2.2} /></span>{item}</li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <Reveal className="section-head">
            <span className="eyebrow">{t('forFamilies.pricing')}</span>
            <h2>{t('forFamilies.pricingTitle')}</h2>
          </Reveal>
          <Reveal>
            <ul className="check-list price-list">
              <li>
                <span className="check-mark"><Icon name="check" size={14} strokeWidth={2.2} /></span>
                <span><strong>{t('forFamilies.pricingGeneral')}</strong></span>
              </li>
              <li>
                <span className="check-mark"><Icon name="check" size={14} strokeWidth={2.2} /></span>
                <span><strong>{t('forFamilies.pricingHotels')}</strong></span>
              </li>
              <li>
                <span className="check-mark"><Icon name="check" size={14} strokeWidth={2.2} /></span>
                <span><strong>{t('forFamilies.pricingEventsLabel')}</strong> <Link to="/contact">{t('forFamilies.pricingEventsCta')}</Link>.</span>
              </li>
            </ul>
          </Reveal>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <Reveal className="cta-band">
            <div>
              <h2>{t('forFamilies.readyTitle')}</h2>
              <p>{t('forFamilies.readyBody')}</p>
            </div>
            <Link className="btn btn-primary btn-lg" to="/register/family">{t('forFamilies.getStarted')}</Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
